// Utilidades de fecha en español (es-AR).

const fmtFechaLarga = new Intl.DateTimeFormat('es-AR', {
  weekday: 'short', day: 'numeric', month: 'short', year: 'numeric',
});
const fmtFechaMedia = new Intl.DateTimeFormat('es-AR', {
  weekday: 'short', day: 'numeric', month: 'short',
});
const fmtHora = new Intl.DateTimeFormat('es-AR', {
  hour: '2-digit', minute: '2-digit',
});

export const formatFechaLarga = (d) => fmtFechaLarga.format(new Date(d));
export const formatFechaMedia = (d) => fmtFechaMedia.format(new Date(d));
export const formatHora = (d) => fmtHora.format(new Date(d)) + ' hs';

/** Clave YYYY-MM-DD (en horario local) para agrupar por día. */
export function claveDia(d) {
  const f = new Date(d);
  const y = f.getFullYear();
  const m = String(f.getMonth() + 1).padStart(2, '0');
  const day = String(f.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** ¿La fecha es futura respecto de ahora? */
export const esFutura = (d) => new Date(d).getTime() > Date.now();

/** Distancia humana aproximada ("en 8 días", "hoy", "mañana"). */
export function relativo(d) {
  const dias = Math.round((new Date(d).getTime() - Date.now()) / 86400000);
  if (dias < 0) return `hace ${Math.abs(dias)} día${Math.abs(dias) === 1 ? '' : 's'}`;
  if (dias === 0) return 'hoy';
  if (dias === 1) return 'mañana';
  return `en ${dias} días`;
}
